import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Plan                  from "../../../domain/plan/Plan";
import Reservation           from "../../../domain/reservation/Reservation";
import ReservationRepository from "../../../domain/reservation/ReservationRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationDataSource from "../../../infrastructure/datasource/reservation/ReservationDataSource";
import GetReservations       from "./GetReservations";

class RegisterReservationPlan {
  private readonly repository: ReservationRepository = new ReservationDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly getReservations: GetReservations = new GetReservations(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(reservation: Reservation, plan: Plan) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.registerPlan(reservation, plan);
      await this.getReservations.execute(reservation.detail.date);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default RegisterReservationPlan;
